import { store } from '@/store/store'
import router from '@/router'

export function authrecheck () {
  if (!store.getters.isAuthenticated) {
    if (router.currentRoute.meta.access_type === 'authorized') {
      router.push({
        path: '/login'
      })
    }
  }
}
